import { render, staticRenderFns } from "./device-settings-templates.vue?vue&type=template&id=5aac2b40&scoped=true"
import script from "./device-settings-templates.vue?vue&type=script&lang=js"
export * from "./device-settings-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac2b40",
  null
  
)

export default component.exports